export default "__VITE_PUBLIC_ASSET__8c3c8292__"